import {useEffect, useCallback} from 'react';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';

import FieldWrapper from '../form/field-wrapper';
import FormControl from '../form/form-control';
import PercentageInput from '../form/percentage-input';
import {AllocationFormSchemaErrors, AllocationFormSchemaType} from './allocation-form-schema';
import {computeAmountSum} from './utils';

export const AllocationTotalField = () => {
  const {t} = useTranslation();
  const {values, errors, setFieldValue} = useFormikContext<AllocationFormSchemaType>();

  useEffect(() => {
    const total = computeAmountSum(values.accounts ?? []);

    setFieldValue('amountTotal', isNaN(total) ? 0 : total);
  }, [setFieldValue, values.accounts]);

  const tError = useCallback(
    (key: AllocationFormSchemaErrors | undefined) => {
      return key ? t(`components.advisor-predetermined-allocation-form.${key}`) : '';
    },
    [t],
  );

  return (
    <FormControl
      isInError={values.amountTotal !== 0 && !!errors.amountTotal}
      errors={values.amountTotal !== 0 ? [tError(errors.amountTotal as AllocationFormSchemaErrors)] : []}
    >
      <FieldWrapper
        label={t('components.advisor-predetermined-allocation-form.label-amount-total')}
        identifier="amount-total"
      >
        <PercentageInput
          data-testid="allocation-amount-total-input"
          name="allocation-amount-total"
          value={values.amountTotal}
          readOnly
          required
        />
      </FieldWrapper>
    </FormControl>
  );
};
